import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL;
const sameHost = () => {
  try {
    return new URL(envBase).host === window.location.host;
  } catch {
    return false;
  }
};
export const BACKEND_URL = typeof window !== "undefined" && !sameHost() ? window.location.origin : envBase;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ralat berlaku. Sila cuba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOGO_URL = "/logo.png";

export const fileUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export const trackConversion = () => {
  try {
    window.gtag && window.gtag("event", "conversion", { send_to: "AW-18329459185/_v7ZCJDI89EcEPGz1aRE" });
  } catch (e) {}
};
